<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<!-- <el-breadcrumb-item>图库</el-breadcrumb-item> -->
					<el-breadcrumb-item><span @click="sp_btn">{{codeName.name}}</span></el-breadcrumb-item>
					<el-breadcrumb-item>
						<span @click="k_btn">
							{{this.$route.query.zName}}
						</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item v-if="k_name">{{k_name}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="gall_cont">
				<div class="gall_item">
					<div class="gall_item_title">
						{{m_name}} {{k_name}}
					</div>
					<div class="gall_item_p" >
						<div class="gall_item_a" v-for="(item,index) in gData.records" :key="index">
                            <img  oncontextmenu="return false;" ondragstart="return false;" :src="item.urls.url" alt="" @click="gall_btn(item)" class="img">
						</div>
					</div>
				</div>
			</div>
			<div class="gall_fy">
				<div class="block">
					<el-pagination :page-sizes="[10, 20, 50, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="gData.current"
					 :page-size="gData.size" layout="total, sizes, prev, pager, next, jumper" :total="gData.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'tk',
				currentPage3: 5,
				m_name: this.$route.query.mName, // 目
				k_name: this.$route.query.kName, // 科
				id: this.$route.query.id, // 科
				params: {
					categoryCode: this.$store.state.gallyIndex,
					categoryId: this.$route.query.id,
					page: 1,
					size: 10,
				},
				gData: '',
			}
		},
		mounted() {
			this.init()
		},
		computed: {
			codeName() {
				let name = ''
				for (let item of this.fldata) {
					if (item.code == this.gallyIndex) {
						name = item
					}
				}
				return name
			},
			gallyIndex() {
				return this.$store.state.gallyIndex
			},
			fldata() {
				return this.$store.state.fldata
			}
		},
		methods: {
			k_btn() {
				this.$router.go(-1)
			},
			sp_btn() {
				this.$router.push({
					path: 'gallery_indexTw'
				})
			},
			gall_btn(item) {
				this.$router.push({path: '/gallery_describe',query: {id: item.id,cName: item.name,kName: item.categoryName,zName: this.$route.query.mName}})
			},
			init() {
				setTimeout(red => {
					this.params.categoryCode = this.gallyIndex
					this.$http.get('/front/gallery/galleries', this.params).then(res => {
						let data = res.data.records
						let newData = []
						for(let item of data) {
							let {imgInfos,...datas} = item
							for(let childitem of imgInfos){
								newData.push({
									urls: {
										...childitem
									},
									...datas
								})
							}
						}
						let resData = res.data
						resData.records = newData
						this.gData = resData
					})
				})
			},
			dec_btn() {
				this.$router.push({path: 'gallery_describe'})
			},
			handleSizeChange(val) {
				this.params.page = 1
				this.params.size =val
				this.init()
			},
			handleCurrentChange(val) {
				this.params.page = val
				this.init()
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	.gall_box{
		//width: 870px;
		width: 1200px;
		margin: 0 auto;
		.gall_mbx{
			margin: 0 0 30px;
			padding: 37px 23px 0;
			span{
				font-size: 13px;
				cursor: pointer;
			}
		}
		.gall_slt{
			display: flex;
			justify-content: flex-end;
			align-items: center;
			cursor: pointer;
			.icon{
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}
			span{
				font-size: 15px;
				color: #22AB67;
			}
		}
		.gall_fy{
			margin: 30px 0 30px;
			padding-bottom: 30px;
			.block{
				display: flex;
				justify-content: center;
			}
		}
		.gall_cont{
			.gall_item{
				margin-top: 21px;
				.gall_item_title{
					height: 42px;
					background: #F5F5F5;
					padding-left: 23px;
					font-size: 18px;
					color: #333333;
					line-height: 42px;
					font-weight: bold;
				}
				.gall_item_p{
					padding: 23px 10px 15px;
					display: flex;
					flex-wrap: wrap;
					margin-bottom: 30px;
					.gall_item_a{
						color: #4A4A4A;
						font-size: 13px;
						text-decoration: underline;
						width: 120px;
						height: 120px;
						margin: 0 25px 30px;
						box-sizing: border-box;
						padding: 4px;
						border: 1px solid #ccc;
						cursor: pointer;
						.img{
							width: 100%;
							height: 100%;
							object-fit: contain;
						}
					}
				}
			}
		}
	}
</style>
